import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { Link } from '../Link'
import { Icon } from '../Icon'

export class BreadCrumb extends React.PureComponent {
  static propTypes = {
    breadCrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        onClick: PropTypes.func,
        active: PropTypes.bool,
        className: PropTypes.string,
      })
    ),
    isPetplace: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    breadCrumbs: [],
    isPetplace: false,
  }

  render() {
    const { id, className, style, refProp, breadCrumbs, isPetplace } = this.props

    return (
      <div
        id={id}
        className={cn('ui-bread-crumb', { 'ui-petplace-bread-crumb' : isPetplace }, className)}
        style={style}
        ref={refProp}
      >
        {breadCrumbs.map((item, index) => {
          return (
            <div className={cn('ui-bread-crumb-link', { 'ui-petplace-bread-crumb-link' : isPetplace })} key={`breadCrumb${index}`}>
              { (isPetplace &&  !item.active) ? <Icon type="chevron_left"></Icon> : '' }
              <Link
                href={item?.href || '#'}
                disabled={item.active}
                onClick={item.onClick}
                className={item?.className}
              >
                {item.name}
              </Link>
              { (!isPetplace &&  !item.active) ? <Icon type="chevron_right"></Icon> : '' }
            </div>
          )
        })}
      </div>
    )
  }
}
